// Sales Documents — only real backend fields (salesDocSchema + /api/sales-docs).
// No category / file_name / tags / version / status (none are persisted).

export interface SalesDoc {
  id: string;
  title: string;
  description?: string;
  /** Document link (backend `filename`, surfaced as `url`). */
  url?: string;
  creator_name?: string;
  created_at?: string;
  uploaded_by?: string | { _id?: string; id?: string; display_name?: string };
}

export interface CreateSalesDocPayload {
  title: string;
  description?: string;
  url?: string;
}

export type UpdateSalesDocPayload = Partial<CreateSalesDocPayload>;

export function getUploaderId(u: SalesDoc['uploaded_by']): string {
  if (!u) return '';
  if (typeof u === 'string') return u;
  return u.id ?? u._id ?? '';
}
